'use client';

import { useRouter } from 'next-nprogress-bar';
import { useCurrentLocale } from '@locales/client';
import { useVisibleState } from '@/shared/hooks/useVisibleState';

export const useAuthModal = () => {
  const locale = useCurrentLocale();
  const router = useRouter();
  const { open, visible, close } = useVisibleState(false);

  const handleOpenAuth = () => {
    const path = `/${locale}/?modal=registration`;
    router.push(path);
    // open();
  };

  return {
    handleOpenAuth,
    visible,
    close,
  };
};
